import React, { createContext, useContext, useEffect, useState } from 'react';
import { extractDataFromArray } from '../../utils/common';
const defaultProvider = {
    scroll: 0,
    isProfile: false,
}

const accessPackageContext = createContext(defaultProvider);

const AccessPackageContextProvider = ({ children }) => {
    const [formData, setFormData] = useState(null);
    const [packagesStepformData, setPackagesStepformData] = useState(null);
    const [createListingPackagesStepCompleted, setCreateListingPackagesStepCompleted] = useState(false);
    const [dataSavedToBackend, setDataSavedToBackend] = useState(false);
    const [activeTab, setActiveTab] = useState(0);


    const componentNameMap = {
        hunting_experience: "Hunting Experience",
        fishing_experience: "Fishing Experience",
        farm_ranch_experience: "Camping Experience",
        bird_watching_experience: "Other Experience",
        camping_experience: "Camping Experience",
        other_experience: "Other Experience",
        general_info: 'General Information',
        media_library: "Photos/Videos",
        duration: 'Duration',
        pricing: 'Price',
        guests: "Guests",
        lodging_option: "Lodging Details",
        hunting_method: 'Hunting Method',
        species: 'Species',
        species_unit: 'Species Unit',
        catch_and_release: 'Catch and Release',
        level: 'Level',
        reviewandsubmit: "Review And Submit"
    };
    const [initialformData, setInitialFormData] = useState(null);
    const [initialPackagesFirstStepformData, setInitialPackagesFirstStepFormData] = useState(null);
    const [disableSave, setDisableSave] = useState(true)

    const [activeComponentId, setActiveComponentId] = useState()
    const [listingSeq, setListingSeq] = useState('')
    const [packageSeq, setPackageSeq] = useState('')
    const [packageType, setpackageType] = useState('')
    const [lodgingDetails, setLodgingDetails] = useState({})
    const [validationCheck, setValidationCheck] = useState(false) // used to show errors in left panel tabs..
    const [editorDialogID, setEditorDialogID] = useState(null)
    const [dataLoaded, setDataLoaded] = useState(false)
    const [openPreviewDailog, setOpenPreviewDailog] = useState(false)
    const [pricePerGuestPerNight, setPricePerGuestPerNight] = useState();
    const [isLodgingAvailable, setIsLodgingAvailable] = useState(false);
    const [isPackageSubmitted, setIsPackageSubmitted] = useState(false);


    const updateNestedData = (keys, newData) => {
        // console.log("packagesStepformData", packagesStepformData);

        // console.log("keys", keys);
        // console.log("newData", newData);
        if (activeComponentId === 'hunting_experience' || activeComponentId === 'fishing_experience' || activeComponentId === 'farm_ranch_experience' || activeComponentId === "bird_watching_experience" || activeComponentId === 'camping_experience' || activeComponentId === 'other_experience') {

            setPackagesStepformData(prevData => {
                let updatedData = { ...prevData };
                let current = updatedData;

                // Traverse the keys to get to the correct nested object
                for (let i = 0; i < keys.length - 1; i++) {
                    const key = keys[i];

                    if (!current[key] || typeof current[key] !== 'object') {
                        current[key] = {}; // Ensure the path exists
                    }
                    current = current[key]; // Move to the next nested level
                }

                const lastKey = keys[keys.length - 1];

                // Merge arrays, objects, or replace primitive values
                if (Array.isArray(current[lastKey]) && Array.isArray(newData)) {
                    current[lastKey] = [...newData]; // Replace the array instead of merging
                } else if (typeof current[lastKey] === 'object' && typeof newData === 'object') {
                    current[lastKey] = { ...current[lastKey], ...newData }; // Merge objects
                } else {
                    current[lastKey] = newData; // Replace primitive values
                }

                return { ...updatedData };
            });

        } else {

            setFormData(prevData => {
                let updatedData = { ...prevData };
                let current = updatedData;

                // Traverse the keys to get to the correct nested object
                for (let i = 0; i < keys.length - 1; i++) {
                    const key = keys[i];

                    if (!current[key] || typeof current[key] !== 'object') {
                        current[key] = {}; // Ensure the path exists
                    }
                    current = current[key]; // Move to the next nested level
                }

                const lastKey = keys[keys.length - 1];

                // Merge arrays, objects, or replace primitive values
                if (Array.isArray(current[lastKey]) && Array.isArray(newData)) {
                    current[lastKey] = [...newData]; // Replace the array instead of merging
                } else if (typeof current[lastKey] === 'object' && typeof newData === 'object') {
                    current[lastKey] = { ...current[lastKey], ...newData }; // Merge objects
                } else {
                    current[lastKey] = newData; // Replace primitive values
                }

                return { ...updatedData };
            });
        }


    };


    useEffect(() => {
        if (activeComponentId === 'reviewandsubmit') {
            setValidationCheck(true)
        }
    }, [activeComponentId])

    useEffect(() => {
        // console.log("initialformData", initialformData);
        if (extractDataFromArray(initialformData, ['status'], '') === 'P') {
            setIsPackageSubmitted(true)
        } else {
            setIsPackageSubmitted(false)
        }
    }, [initialformData])

    const values = {
        formData,
        setFormData,
        updateNestedData,
        activeComponentId,
        setActiveComponentId,
        listingSeq,
        setListingSeq,
        packageType,
        setpackageType,
        componentNameMap,
        packageSeq, setPackageSeq,
        initialformData, setInitialFormData,
        disableSave, setDisableSave,
        packagesStepformData, setPackagesStepformData,
        createListingPackagesStepCompleted, setCreateListingPackagesStepCompleted,
        initialPackagesFirstStepformData, setInitialPackagesFirstStepFormData,
        dataSavedToBackend, setDataSavedToBackend,
        lodgingDetails, setLodgingDetails,
        editorDialogID, setEditorDialogID,
        validationCheck, setValidationCheck,
        activeTab, setActiveTab,
        dataLoaded, setDataLoaded,
        pricePerGuestPerNight, setPricePerGuestPerNight,
        openPreviewDailog, setOpenPreviewDailog,
        isLodgingAvailable, setIsLodgingAvailable,
        isPackageSubmitted, setIsPackageSubmitted
    }

    return (
        <accessPackageContext.Provider value={values} >
            {children}
        </accessPackageContext.Provider>
    );
};
const AccessPackageContext = () => {
    return useContext(accessPackageContext)
}

export { AccessPackageContext, AccessPackageContextProvider }
